import { Route } from 'vue-router';
import LccaScenarioInfo from '@/modules/lcca/views/1 - ScenarioInfo.vue';
import LccaTrafficData from '@/modules/lcca/views/2 - Traffic Data.vue';
import LccaTrafficDistribution from '@/modules/lcca/views/3 - Traffic Distribution.vue';
import LccaUserTime from '@/modules/lcca/views/4 - Value of User Time.vue';
import LccaAlternatives from '@/modules/lcca/views/5 - Alternatives.vue';
import LccaReport from '@/modules/lcca/views/6 - Report.vue';
import LccaScenarioContainer from '@/modules/lcca/views/components/LccaScenarioContainer.vue';


export const lccaPages = [
  { link: '1', text: 'Scenario Information' },
  // {link: '2', text: 'Analysis Options'},
  { link: '2', text: 'Traffic Data' },
  { link: '3', text: 'Traffic Distribution' },
  { link: '4', text: 'Value of User Time' },
  { link: '5', text: 'Alternatives' },
  { link: '6', text: 'Result' },
];

export const lccaRoutes = {
  path: '/projects/lcca/:id',
  name: 'lcca',
  redirect: '/projects/lcca/:id/1',
  component: LccaScenarioContainer,
  props: (route: Route) => ({
    id: route.params.id,
    pages: lccaPages,
  }),
  children: [
    {
      path: '1',
      component: LccaScenarioInfo,
      props: (route: Route) => ({ id: route.params.id, page: 1 }),
    },
    // {
    //   path: '2',
    //   component: LccaAnalysisOptions,
    //   props: (route: Route) => ({id: route.params.id, page: 2}),
    // },
    {
      path: '2',
      component: LccaTrafficData,
      props: (route: Route) => ({ id: route.params.id, page: 2 }),
    },
    {
      path: '3',
      component: LccaTrafficDistribution,
      props: (route: Route) => ({ id: route.params.id, page: 3 }),
    },
    {
      path: '4',
      component: LccaUserTime,
      props: (route: Route) => ({ id: route.params.id, page: 4 }),
    },
    {
      path: '5',
      component: LccaAlternatives,
      props: (route: Route) => ({ id: route.params.id, page: 5 }),
    },
    {
      path: '6',
      component: LccaReport,
      props: (route: Route) => ({ id: route.params.id, page: 6 }),
    },
  ],
};
